module.exports = __webpack_public_path__ + "res/4-img_button_bg.6183c18c5daac95af30491a690f64eaf.png";